export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5372.f77b66ef.jpg";